import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const ColumnChartStatistics = ({ siteList = [], SDVList = [], chartLoader }) => {
  const [chartOptions, setChartOptions] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      colors: [
        "#006400", // Dark green
        "#228B22", // Medium-dark green
        "#32CD32", // Medium green (LimeGreen)
        "#90EE90", // Light green
        "#CCFFCC"  // Very light green
      ],
      legend: {
        position: "bottom",
      },
    },
  });

  useEffect(() => {
    if (siteList.length && SDVList.length) {
      setChartOptions((prev) => ({
        ...prev,
        series: [
          {
            name: "SDV",
            data: SDVList,
          },
        ],
        options: {
          ...prev.options,
          xaxis: {
            categories: siteList,
          },
        },
      }));
    }
  }, [siteList, SDVList]);

  return (
    <div className="p-2">
      <h5 className="fw-bold mb-1 text-center w-100 mt-2">SDV Chart</h5>
      {chartLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
        chartOptions.series.length > 0 && (
          <ReactApexChart
            options={chartOptions.options}
            series={chartOptions.series}
            type="bar"
            height={302}
          />
        )}
    </div>
  );
};

export default ColumnChartStatistics;